import { render, staticRenderFns } from "./createBack.vue?vue&type=template&id=491c9620&"
import script from "./createBack.vue?vue&type=script&lang=js&"
export * from "./createBack.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports